// extracted by mini-css-extract-plugin
export default {"container":"Experience_container__fmXJ7","smallText":"Experience_smallText__M51of","left":"Experience_left__Rowht","right":"Experience_right__NTvkd"};